/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';
import { parseData } from '../util/data';
import { apiClient } from '../util/http';

export const findByCompany = async (companyId) => {
  const { data } = await apiClient.get(`/benefit-order-parameter/${companyId}`);
  return parseData(data);
};

export const updateByCompany = async (companyId, payload) => {
  const { data } = await apiClient.patch(`/benefit-order-parameter/${companyId}`, payload);
  return parseData(data);
};

export const useParameterByModule = (companyId) =>
  useQuery({
    queryKey: ['benefit-order-parameter', companyId],
    queryFn: () => findByCompany(companyId),
    enabled: !!companyId,
    refetchOnWindowFocus: false,
  });
